import { useEffect, useState } from "react";
import { Card, ProgressBar } from "react-bootstrap";
import { generateDynamicCSS } from "../../ComponentsMap";
import './ProgressingDonationCard.css'
import { ARCURRENCY } from "../../Constants";
import { Link } from "react-router-dom";
const ProgressingDonationCard = (props) => {
    // Fix: Properly calculate percentage and handle division by zero
    const current = Number(props?.currentAmount) || 0;
    const target = Number(props?.targetAmount) || 0;
    const percentage = target > 0 ? (current / target) * 100 : 0;

    // useEffect(() => {
    //     if (props.style)
    //         generateDynamicCSS(props.className, props.style);
    // }, [props.className, props.style]);

    const shouldAnimate = props.animation && props.animation.animationType && props.animation.animationType !== 'none';
    return (
        <Link to={`/campaigns/${props.name}?id=${props.id}`} className="p-2 col-lg-4 col-md-6 col-sm-6 col-12 nav-link">
            <Card 
                className={` p-2 Pointer DonationCard ${props.className} ProgressingDonationCard ${props.display === "overlayed" ? "overlayed" : "normal"}`} 
                key={props.id}
                {...(shouldAnimate ? {
                    'data-aos': props.animation.animationType,
                    'data-aos-duration': Number(props.animation.animationDuration),
                    'data-aos-delay': Number(props.animation.animationDelay),
                } : {})}
            >
                <div className="DonationCardImageContainer ProgressingDonationCardImageContainer">
                    <Card.Img variant="top" src={props.mainImage} />
                </div>
                <Card.Body className="Center ProgressingDonationCardText DonationCardBody" >
                    <Card.Title>{props.name}</Card.Title>
                    <Card.Text>
                        {props.description.substring(0, 90)+"..."}
                    </Card.Text>
                    <div className="ProgressDonationCardCounts" dir={"ltr"}>
                        <span>{Number(current).toLocaleString() + " " + ARCURRENCY}</span>
                        <span>{Number(target).toLocaleString() + " " + ARCURRENCY}</span>
                    </div>
                    <ProgressBar dir={"ltr"} className="ProgressingDonationCardProgressBar w-100"  now={percentage} label={`${percentage.toFixed(2)}%`} />
                </Card.Body> 
            </Card>
        </Link>
    );
}

export default ProgressingDonationCard;